import { clsx } from 'clsx'
import { type FC, type ReactElement } from 'react'

type ProductDiscountProps = {
  className?: string
  'data-qa-id'?: string
  discount: number | string
  label?: ReactElement
  supNote?: number | string
}
export const ProductDiscount: FC<ProductDiscountProps> = ({
  className,
  'data-qa-id': dataQaId,
  discount,
  label = null,
  supNote,
}) => {
  return (
    <div
      className={clsx(
        'flex min-w-12 items-center justify-center p-1 text-dark-primary-max',
        className,
      )}
      data-qa-id={dataQaId}
    >
      {label}
      <span>{discount}</span>
      {supNote ? <sup style={{ fontSize: '8px' }}>{supNote}</sup> : null}
    </div>
  )
}
